// ============================================================
// Tour Expense System — API Service Layer
// ============================================================

export const API_BASE = 'https://api.benfortetech.com/tour.php';
export const TOKEN_KEY   = 'tour_token';
export const TOKEN_EXPIRY_KEY = 'tour_token_expiry';
const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

export function saveToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(TOKEN_EXPIRY_KEY, String(Date.now() + ONE_YEAR_MS));
}

export function getToken() {
  const expiry = parseInt(localStorage.getItem(TOKEN_EXPIRY_KEY) || '0');
  if (Date.now() > expiry) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_EXPIRY_KEY);
    return '';
  }
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
}

async function request(method, path, body = null) {
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`,
    },
  };
  if (body !== null) opts.body = JSON.stringify(body);
  const url = `${API_BASE}?path=${encodeURIComponent(path)}`;
  const res = await fetch(url, opts);
  if (res.status === 401) {
    clearToken();
    window.location.reload();
    return;
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const api = {
  login: (password) => fetch(`${API_BASE}?path=%2Flogin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  }).then(r => r.json()),

  getState: ()                => request('GET', '/state'),
  updateFamily: (id, body)    => request('PUT', `/families/${id}`, body),
  addMember: (body)           => request('POST', '/members', body),
  updateMember: (id, body)    => request('PUT', `/members/${id}`, body),
  deleteMember: (id)          => request('DELETE', `/members/${id}`),
  addExpense: (body)          => request('POST', '/expenses', body),
  updateExpense: (id, body)   => request('PUT', `/expenses/${id}`, body),
  deleteExpense: (id)         => request('DELETE', `/expenses/${id}`),
  addPayment: (body)          => request('POST', '/payments', body),
  deletePayment: (id)         => request('DELETE', `/payments/${id}`),
  addContact: (body)          => request('POST', '/contacts', body),
  deleteContact: (id)         => request('DELETE', `/contacts/${id}`),
  addNote: (body)             => request('POST', '/notes', body),
  deleteNote: (id)            => request('DELETE', `/notes/${id}`),
  addTicket: (body)           => request('POST', '/tickets', body),
  deleteTicket: (id)          => request('DELETE', `/tickets/${id}`),
  reset: ()                   => request('POST', '/reset'),
};
